import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form", attrs: { id: "labelGenForm" } },
    [
      _vm.loaded
        ? _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(VTextField, {
                attrs: { label: "Product", required: false },
                model: {
                  value: _vm.labelGen.product_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.labelGen, "product_id", $$v)
                  },
                  expression: "labelGen.product_id",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Brand", required: false },
                model: {
                  value: _vm.labelGen.brand,
                  callback: function ($$v) {
                    _vm.$set(_vm.labelGen, "brand", $$v)
                  },
                  expression: "labelGen.brand",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Inventory Id", required: false },
                model: {
                  value: _vm.labelGen.inventory_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.labelGen, "inventory_id", $$v)
                  },
                  expression: "labelGen.inventory_id",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Prefix", required: true },
                model: {
                  value: _vm.labelGen.prefix,
                  callback: function ($$v) {
                    _vm.$set(_vm.labelGen, "prefix", $$v)
                  },
                  expression: "labelGen.prefix",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Code", required: true },
                model: {
                  value: _vm.labelGen.code,
                  callback: function ($$v) {
                    _vm.$set(_vm.labelGen, "code", $$v)
                  },
                  expression: "labelGen.code",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Weights", required: false },
                model: {
                  value: _vm.labelGen.weights,
                  callback: function ($$v) {
                    _vm.$set(_vm.labelGen, "weights", $$v)
                  },
                  expression: "labelGen.weights",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Stock Date", required: true },
                model: {
                  value: _vm.labelGen.stock_date,
                  callback: function ($$v) {
                    _vm.$set(_vm.labelGen, "stock_date", $$v)
                  },
                  expression: "labelGen.stock_date",
                },
              }),
              _c(
                "div",
                { staticClass: "mt-4 d-flex justify-space-between" },
                [
                  _c(VBtn, { on: { click: _vm.goBack } }, [
                    _vm._v(" Back "),
                  ]),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(" " + _vm._s(_vm.id ? "Update" : "Save") + " ")]
                  ),
                  _c("span"),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }